import React from 'react'
import Card from '../Card'
import { useTranslation } from 'next-i18next'
import { classNames } from '../../lib/utils/classNames'

type CardProps = {
  fundingStatus: 'funding' | 'funded' | 'reimbursed' | 'paused' | 'not_started'
  label?: string
  className?: string
}

export default function Badge({ fundingStatus, label, className }: CardProps) {
  const { t } = useTranslation('common')

  const badgeConfig = {
    funding: {
      label: label ?? t('propertyCard.badges.funding.title'),
      className: 'bg-green-50 text-green-800 ring-green-200/80',
    },
    funded: {
      label: label ?? t('propertyCard.badges.funded.title'),
      className: 'bg-emerald-50 text-emerald-800 ring-emerald-200/80',
    },
    reimbursed: {
      label: label ?? t('propertyCard.badges.reimbursed.title'),
      className: 'bg-teal-50 text-teal-800 ring-teal-200/80',
    },
    paused: {
      label: label ?? t('propertyCard.badges.paused.title'),
      className: 'bg-amber-50 text-amber-800 ring-amber-200/80',
    },
    not_started: {
      label: label ?? t('propertyCard.badges.notStarted.title'),
      className: 'bg-slate-100 text-slate-700 ring-slate-200/80',
    },
  }[fundingStatus]

  return (
    <Card
      className={classNames(
        'relative inline-flex items-center !rounded-md px-3 py-1.5 text-xs font-medium ring-1 ring-inset',
        badgeConfig.className,
        className || '',
      )}
    >
      <span>{badgeConfig.label}</span>
    </Card>
  )
}
